<script setup>
import { useSnackBar } from '@/utils/stores/snackbar'
import { useGenerateImageVariant } from '@core/composable/useGenerateImageVariant'
import authV2ForgotPasswordIllustrationDark from '@images/pages/auth-v2-forgot-password-illustration-dark.png'
import authV2ForgotPasswordIllustrationLight from '@images/pages/auth-v2-forgot-password-illustration-light.png'
import authV2MaskDark from '@images/pages/misc-mask-dark.png'
import authV2MaskLight from '@images/pages/misc-mask-light.png'

const snackbarStore = useSnackBar()
const refForm = ref()
const email = ref('')
const router = useRouter()
const route = useRoute()

const authThemeImg = useGenerateImageVariant(authV2ForgotPasswordIllustrationLight, authV2ForgotPasswordIllustrationDark)
const authThemeMask = useGenerateImageVariant(authV2MaskLight, authV2MaskDark)

definePage({
  meta: {
    layout: 'blank',
    unauthenticatedOnly: true,
  },
})

const sendResetLink = async () => {
  const res = await $api('/auth/forgot-password', {
    method: 'POST',
    body: {
      email: email.value,
    },
    onResponseError({ response }) {
      // errors.value = response._data.errors
    },
  })

  snackbarStore.showSnackBar("발송된 이메일을 통해 비밀번호 설정 후 로그인 하세요.", undefined, undefined, 5000)

  await nextTick(() => {
    router.replace(route.query.to ? String(route.query.to) : '/')
  })
}


const onSubmit = () => {
  refForm.value?.validate().then(({ valid: isValid }) => {
    if (isValid)
      sendResetLink()
  })
}
</script>

<template>
  <div class="auth-wrapper d-flex align-center justify-center pa-4">
    <div class="position-relative my-sm-16">
      <VCard
        class="auth-card pa-4"
        max-width="448"
      >
        <VCardText>
          <h4 class="text-h4 mb-1">
            비밀번호를 잊으셨나요? 🔒
          </h4>
          <p class="mb-0">
            이메일을 입력하시면 비밀번호 재설정 메일을 보내드립니다.
          </p>
        </VCardText>

        <VCardText>
          <VForm
            ref="refForm"
            @submit.prevent="onSubmit"
          >
            <VRow>
              <!-- email -->
              <VCol cols="12">
                <AppTextField
                  v-model="email"
                  autofocus
                  label="이메일"
                  type="email"
                  :rules="[requiredValidator, emailValidator]"
                />
              </VCol>

              <!-- Reset link -->
              <VCol cols="12">
                <VBtn
                  block
                  type="submit"
                >
                  이메일 발송
                </VBtn>
              </VCol>

              <!-- back to login -->
              <VCol cols="12">
                <RouterLink
                  class="d-flex align-center justify-center"
                  :to="{ name: 'login' }"
                >
                  <VIcon
                    icon="tabler-chevron-left"
                    class="flip-in-rtl"
                  />
                  <span>로그인 화면으로</span>
                </RouterLink>
              </VCol>
            </VRow>
          </VForm>
        </VCardText>
      </VCard>
    </div>
  </div>
</template>

<style lang="scss">
@use "@core/scss/template/pages/page-auth.scss";
</style>
